import { useNavigate } from "react-router-dom";
import config from "../../config/config";
import { Box, Stack, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import axios from "axios";

const Header = () => {
  const navigate = useNavigate();
  const [nearestMall, setNearestMall] = useState({ name: "" });
  const [allMall, setAllMall] = useState([]);
  const [error, setError] = useState(null);
  const [showDropDown, setShowDropDown] = useState(false);
  const [ipInfo, setIpInfo] = useState({ latitude: null, longitude: null });

  const fetchLocation = async (lat, lng) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          const nearestMallResponse = await axios.get(
            `${config.backendUrl}/location/get_nearest_mall?lat=${latitude}&lng=${longitude}`
          );

          // console.log("response", nearestMallResponse)
          setNearestMall({ name: nearestMallResponse.data?.mall?.name });
          setAllMall(nearestMallResponse.data?.allMalls);
        },
        async (err) => {
          setError(
            "Unable to fetch location. Please enable location services."
          );
          fetchLocationViaIp(lat, lng);
        }
      );
    } else {
      fetchLocationViaIp(lat, lng);
    }
  };

  const fetchLocationViaIp = async (lat, lng) => {
    axios
      .get(
        `${config.backendUrl}/location/get_nearest_mall?lat=${lat}&lng=${lng}`
      )
      .then((response) => {
        setNearestMall({ name: response.data?.mall?.name });
        setAllMall(response.data?.allMalls);
        // setError("Geolocation is not supported by your browser.");
      });
  };

  useEffect(() => {
    axios
      .get("https://ipapi.co/json?access_key=e8d395e0f2c259f5c4b281680485dbd8")
      .then(async (data) => {
        // setIpInfo({
        //   latitude: data.data?.latitude,
        //   longitude: data.data?.longitude,
        // });
        fetchLocation(data.data?.latitude, data.data?.longitude);
      })
      .catch((err) => console.error("Error fetching IP:", err));

    // fetchLocation();
  }, []);

  return (
    <Box
      sx={{
        py: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mx: 1,
      }}
    >
      <img
        src={require("../../assets/images/handpik.png")}
        alt="logo"
        width={162}
        height={32}
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/")}
      />
      {/* <img
        src={require("../../assets/images/avatar_placeholder.png")}
        alt="avatar"
        style={{
          width: "25px",
          height: "25px",
          borderRadius: "50%",
          border: "1px solid #000",
        }}
      /> */}
      <Box>
        {/* {showDropDown === false ? (
          <Typography
            sx={{
              fontFamily: "Poppins-ExtraLight",
              fontSize: "12px",
              color: colors.textColor,
            }}
          >
            Location
          </Typography>
        ) : (
          ""
        )} */}

        <Stack direction="row" alignItems="right">
          {/* {showDropDown === false ? (
            <>
              <MyLocationSharp
                sx={{ color: "#4FCE00", height: "12px", width: "12px" }}
              />
            </>
          ) : (
            <>
              <CloseOutlinedIcon
                onClick={() => {
                  setShowDropDown(false);
                }}
                sx={{ color: "red", height: "12px", width: "12px" }}
              />
            </>
          )} */}
          {/* {showDropDown === false ? (
            <>
              <Typography
                sx={{
                  fontFamily: "Poppins-Medium",
                  fontSize: "10px",
                  color: colors.textColor,
                  ml: 1,
                }}
              >
                {nearestMall?.name}&nbsp;
                <Typography
                  component={"span"}
                  sx={{
                    color: "#82b1ff",
                    textDecoration: "underline",
                    BorderBottom: "1px solid #82b1ff",
                    fontSize: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowDropDown(true);
                  }}
                >
                  Update location?
                </Typography>
              </Typography>
            </>
          ) : ( */}
          {/* <>
            <CreateDropDown
              value={nearestMall?.name}
              setValue={(value) => {
                setNearestMall({ name: value });
                setShowDropDown(false);
              }}
              title=""
              data={allMall}
              noIcon
            />
          </> */}
          {/* )} */}
        </Stack>
      </Box>
    </Box>
  );
};

export default Header;
